module.exports = __webpack_public_path__ + "img/00009.a8e6012e.webp";